import { fromJS } from 'immutable';
import apiActions from 'react/api/actions';
const { licenseStatusModal: { actions } } = apiActions; 

const initialState = fromJS({
  isCancelable: false,
  isOpen: false,
  isExpanded: true,
  position: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.licenseStatusModalShowed:
      return state.merge({ isOpen: true, ...action.payload });
    case actions.licenseStatusModalPositionChanged:
      return state.mergeIn(["position"], fromJS(action.payload));
    case actions.licenseStatusModalClosed:
      return state.set("isOpen", false);
    case actions.licenseStatusModalRetracted:
      return state.set("isExpanded", false);
    case actions.licenseStatusModalExpanded:
      return state.set("isExpanded", true);
    default:
      return state;
  }
};
